import { callApi } from '@/services/WebApi';

export const getIndividualById = (id) => {
  return callApi("GET", `account/individual/${id}`);
};

